import React from 'react';
import { node, string } from 'prop-types';
import classnames from 'classnames';
import './index.css';

const Container = ({ children, className, ...rest }) => (
  <div className={classnames('TabContainer__container', className)} {...rest}>
    {children}
  </div>
);

Container.propTypes = {
  children: node,
  className: string,
};

Container.defaultProps = {
  children: null,
  className: null,
};

export default Container;



// WEBPACK FOOTER //
// ../ui-components/components/Tab/Container/index.jsx